export default __webpack_public_path__ + "static/media/announcement_horn.107df811.png";